module.exports = __webpack_public_path__ + "img/megaphone-1.45a28cc3.svg";